/**
 * Toolbar template and icons
 */

import { t } from '../../core/i18n';

/** SVG Icons */
export const icons = {
  annotation: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <circle cx="12" cy="12" r="6"/>
    <circle cx="12" cy="12" r="2"/>
  </svg>`,

  freeze: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <path d="M12 2v20M2 12h20M4.93 4.93l14.14 14.14M19.07 4.93L4.93 19.07"/>
  </svg>`,

  unfreeze: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <polygon points="5 3 19 12 5 21 5 3"/>
  </svg>`,

  eye: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
    <circle cx="12" cy="12" r="3"/>
  </svg>`,

  eyeOff: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
    <line x1="1" y1="1" x2="23" y2="23"/>
  </svg>`,

  eyeDot: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
    <circle cx="12" cy="12" r="1.5" fill="currentColor"/>
  </svg>`,

  copy: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"/>
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
  </svg>`,

  trash: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <polyline points="3 6 5 6 21 6"/>
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
    <line x1="10" y1="11" x2="10" y2="17"/>
    <line x1="14" y1="11" x2="14" y2="17"/>
  </svg>`,

  sun: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="12" cy="12" r="5"/>
    <line x1="12" y1="1" x2="12" y2="3"/>
    <line x1="12" y1="21" x2="12" y2="23"/>
    <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/>
    <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
    <line x1="1" y1="12" x2="3" y2="12"/>
    <line x1="21" y1="12" x2="23" y2="12"/>
    <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/>
    <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
  </svg>`,

  moon: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
  </svg>`,

  x: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <line x1="18" y1="6" x2="6" y2="18"/>
    <line x1="6" y1="6" x2="18" y2="18"/>
  </svg>`,

  settings: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="12" cy="12" r="3"/>
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/>
  </svg>`,

  multiSelect: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <rect x="3" y="3" width="7" height="7"/>
    <rect x="14" y="3" width="7" height="7"/>
    <rect x="14" y="14" width="7" height="7"/>
    <rect x="3" y="14" width="7" height="7"/>
  </svg>`,

  check: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <polyline points="20 6 9 17 4 12"/>
  </svg>`,
};

/**
 * Render collapsed toolbar
 */
export function renderCollapsedToolbar(annotationCount: number): string {
  return `
    <div class="toolbar collapsed" data-annotation-toolbar>
      <button class="toolbar-btn toggle-btn" title="${t('toolbar.activate')}" data-action="toggle">
        ${icons.annotation}
        ${annotationCount > 0 ? `<span class="badge">${annotationCount}</span>` : ''}
      </button>
    </div>
  `;
}

/**
 * Render expanded toolbar
 */
export function renderExpandedToolbar(options: {
  annotationCount: number;
  isFrozen: boolean;
  markerVisibility: 'full' | 'dots' | 'hidden';
  isDarkMode: boolean;
  showCopiedFeedback: boolean;
  showClearedFeedback: boolean;
  showEntranceAnimation?: boolean;
  settingsPanelHtml?: string;
  annotationsPanelHtml?: string;
}): string {
  const {
    annotationCount,
    isFrozen,
    markerVisibility,
    isDarkMode,
    showCopiedFeedback,
    showClearedFeedback,
    showEntranceAnimation = false,
    settingsPanelHtml = '',
    annotationsPanelHtml = '',
  } = options;

  const eyeIcon = markerVisibility === 'full'
    ? icons.eye
    : markerVisibility === 'dots'
      ? icons.eyeDot
      : icons.eyeOff;
  const eyeActive = markerVisibility !== 'hidden';
  const eyeTitle = markerVisibility === 'full'
    ? t('toolbar.dotsMode')
    : markerVisibility === 'dots'
      ? t('toolbar.hideMarkers')
      : t('toolbar.showMarkers');

  return `
    <div class="toolbar${showEntranceAnimation ? ' entering' : ''}" data-annotation-toolbar>
      ${showCopiedFeedback ? `<div class="feedback success">${t('toolbar.copiedFeedback')}</div>` : ''}
      ${showClearedFeedback ? `<div class="feedback">${t('toolbar.clearedFeedback')}</div>` : ''}
      ${settingsPanelHtml}
      ${annotationsPanelHtml}

      <button class="toolbar-btn ${isFrozen ? 'active' : ''}" title="${isFrozen ? t('toolbar.unfreeze') : t('toolbar.freeze')}" data-action="freeze">
        ${isFrozen ? icons.unfreeze : icons.freeze}
      </button>

      <button class="toolbar-btn ${eyeActive ? 'active' : ''}" title="${eyeTitle}" data-action="toggle-markers">
        ${eyeIcon}
      </button>

      <div class="separator"></div>

      <button class="toolbar-btn annotation-count-btn" title="${t('toolbar.annotations')}" data-action="annotations">
        ${icons.annotation}
        <span class="count">${annotationCount}</span>
      </button>

      <div class="separator"></div>

      <button class="toolbar-btn" title="${t('toolbar.copyToClipboard')}" data-action="copy" ${annotationCount === 0 ? 'disabled' : ''}>
        ${icons.copy}
      </button>

      <button class="toolbar-btn" title="${t('toolbar.clearAll')}" data-action="clear" ${annotationCount === 0 ? 'disabled' : ''}>
        ${icons.trash}
      </button>

      <div class="separator"></div>

      <button class="toolbar-btn" title="${t('toolbar.toggleTheme')}" data-action="theme">
        ${isDarkMode ? icons.sun : icons.moon}
      </button>

      <button class="toolbar-btn" title="${t('toolbar.settings')}" data-action="settings">
        ${icons.settings}
      </button>

      <button class="toolbar-btn" title="${t('toolbar.close')}" data-action="close">
        ${icons.x}
      </button>
    </div>
  `;
}
